import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import {
  FaPizzaSlice,
  FaClipboardList,
  FaClock,
  FaChartBar,
  FaBell,
  FaUsers,
  FaStopwatch,
  FaChartLine,
  FaCheckCircle,
  FaDownload,
  FaStar,
  FaArrowRight,
  FaCog,
  FaStore,
  FaUtensils,
  FaReceipt,
  FaEye,
} from "react-icons/fa";
import "./PizzaQueuePage.css";

const PizzaQueuePage = () => {
  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const features = [
    {
      icon: FaClipboardList,
      title: "Automatické spracovanie objednávok",
      description:
        "Systém automaticky prijíma a spracúva objednávky z rôznych kanálov do jednotnej fronty",
    },
    {
      icon: FaClock,
      title: "Inteligentné plánovanie výroby",
      description:
        "Optimalizuje výrobnú frontu podľa typu pizze, času prípravy a aktuálneho vyťaženia kuchyne",
    },
    {
      icon: FaChartBar,
      title: "Sledovanie v reálnom čase",
      description:
        "Kontinuálny monitoring stavu každej objednávky od prijatia po vydanie zákazníkovi",
    },
    {
      icon: FaBell,
      title: "Notifikačný systém",
      description:
        "Automatické upozornenia pre kuchárov a personál o dôležitých udalostiach vo výrobe",
    },
    {
      icon: FaUsers,
      title: "Koordinácia tímu",
      description:
        "Efektívne rozdelenie úloh medzi kuchárov a optimalizácia pracovných postupov",
    },
    {
      icon: FaChartLine,
      title: "Analytika a reporty",
      description:
        "Podrobné štatistiky výroby, času prípravy a výkonnosti reštaurácie",
    },
  ];

  const benefits = [
    {
      icon: FaStopwatch,
      title: "Čas prípravy",
      value: "40%",
      description: "Zníženie priemerného času prípravy objednávok",
    },
    {
      icon: FaChartLine,
      title: "Efektivita výroby",
      value: "65%",
      description: "Zvýšenie celkovej efektivity výrobných procesov",
    },
    {
      icon: FaCheckCircle,
      title: "Presnosť objednávok",
      value: "98%",
      description: "Eliminovanie chýb a zabezpečenie správneho spracovania",
    },
    {
      icon: FaUsers,
      title: "Spokojnosť zákazníkov",
      value: "85%",
      description: "Rast spokojnosti vďaka rýchlejšiemu a presnejšiemu servisu",
    },
  ];

  const industries = [
    {
      icon: FaPizzaSlice,
      title: "Pizzerie",
      description: "Špecializované riešenie pre pizzerie všetkých veľkostí",
    },
    {
      icon: FaStore,
      title: "Reštauračné reťazce",
      description: "Centralizované riadenie výroby vo viacerých pobočkách",
    },
    {
      icon: FaUtensils,
      title: "Fast food",
      description: "Optimalizácia pre rýchle občerstvenie s pizzou v ponuke",
    },
    {
      icon: FaReceipt,
      title: "Delivery služby",
      description: "Integrácia s rozvozovými službami a online objednávkami",
    },
  ];

  const testimonials = [
    {
      name: "Marko Novák",
      company: "Pizza Express Bratislava",
      text: "PizzaQueue úplne zmenil náš spôsob práce. Dokážeme teraz zvládnuť dvojnásobne viac objednávok s rovnakým počtom ľudí.",
      rating: 5,
    },
    {
      name: "Petra Kováčová",
      company: "Mama Mia Pizza",
      text: "Systém nám pomohol eliminovať chyby v objednávkach a zákazníci sú spokojnejší s rýchlosťou dodania.",
      rating: 5,
    },
  ];

  return (
    <div className="pizzaqueue-page">
      {/* Hero Section */}
      <section className="pizzaqueue-hero">
        <div className="container">
          <div className="hero-content">
            <div className="hero-text">
              <h1>PizzaQueue</h1>
              <h2>Systém pre riadenie výroby pizze</h2>
              <p>
                Moderný softvérový systém navrhnutý pre efektívne riadenie
                výroby pizze v reštauračných prevádzkach. Umožňuje presné
                plánovanie, sledovanie a optimalizáciu výrobných procesov v
                reálnom čase. Systém spracúva každú objednávku automaticky a
                zaraďuje ju do výrobnej fronty podľa aktuálneho vyťaženia
                kuchyne.
              </p>
              <div className="hero-actions">
                <Link to="/kontakt" className="btn btn-primary">
                  <FaArrowRight /> Získať ponuku
                </Link>
              </div>
            </div>
            <div className="hero-image">
              <img src="/pizza_queue.png" alt="PizzaQueue" className="hero-product-image" />
            </div>
          </div>
        </div>
      </section>

      {/* Technologies Section */}
      <section className="technologies-section">
        <div className="container">
          <h2>Použité technológie</h2>
          <div className="technologies-grid">
            <div className="technology-card">
              <div className="tech-name">C#</div>
            </div>
            <div className="technology-card">
              <div className="tech-name">SQL</div>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="features-section">
        <div className="container">
          <h2>Kľúčové funkcie</h2>
          <div className="features-grid">
            {features.map((feature, index) => (
              <div key={index} className="feature-card">
                <div className="feature-icon">
                  <feature.icon />
                </div>
                <h4>{feature.title}</h4>
                <p>{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="benefits-section">
        <div className="container">
          <h2>Merateľné výsledky</h2>
          <div className="benefits-grid">
            {benefits.map((benefit, index) => (
              <div key={index} className="benefit-card">
                <div className="benefit-icon">
                  <benefit.icon />
                </div>
                <div className="benefit-value">{benefit.value}</div>
                <h4>{benefit.title}</h4>
                <p>{benefit.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Industries Section */}
      <section className="industries-section">
        <div className="container">
          <h2>Ideálne pre</h2>
          <div className="industries-grid">
            {industries.map((industry, index) => (
              <div key={index} className="industry-card">
                <industry.icon className="industry-icon" />
                <h4>{industry.title}</h4>
                <p>{industry.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Customer Section */}
      <section className="customers-section">
        <div className="container">
          <h2>Náš klient</h2>
          <div className="customers-grid">
            <a 
              href="https://360pizza.com/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="customer-card"
            >
              <img src="/360pizza_logo.png" alt="360 Pizza" />
              <h3>360 Pizza</h3>
              <p>Moderná pizzéria s inovatívnym prístupom k príprave pizze</p>
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PizzaQueuePage;
